module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.step) ? _c('div', {
    staticClass: "pa-3"
  }, [_c('v-system-bar', {
    staticClass: "mb-5",
    attrs: {
      "window": "",
      "rounded": ""
    }
  }, [_vm._v(_vm._s(_vm.step.title))]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-3",
    attrs: {
      "xoutlined": "",
      "dense": "",
      "label": "Title",
      "hide-details": ""
    },
    model: {
      value: (_vm.step.title),
      callback: function($$v) {
        _vm.$set(_vm.step, "title", $$v)
      },
      expression: "step.title"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Used in templates and formulas",
      "dense": ""
    },
    model: {
      value: (_vm.usedInTemplates),
      callback: function($$v) {
        _vm.usedInTemplates = $$v
      },
      expression: "usedInTemplates"
    }
  }), _vm._v(" "), (_vm.usedInTemplates) ? _c('v-text-field', {
    attrs: {
      "xoutlined": "",
      "dense": "",
      "label": "Name"
    },
    model: {
      value: (_vm.step.name),
      callback: function($$v) {
        _vm.$set(_vm.step, "name", $$v)
      },
      expression: "step.name"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "xoutlined": "",
      "dense": "",
      "label": "Type",
      "items": _vm.stepTypes
    },
    model: {
      value: (_vm.step.type),
      callback: function($$v) {
        _vm.$set(_vm.step, "type", $$v)
      },
      expression: "step.type"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "xoutlined": "",
      "dense": "",
      "label": "Importance",
      "items": _vm.importanceLevels
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticStyle: {
            "padding-left": "10px",
            "background-size": "120px",
            "background-position": "0px 0px",
            "width": "100%",
            "min-width": "200px"
          },
          style: (_vm.getBackgroundStyle(item.value))
        }, [_vm._v(_vm._s(item.text))])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticStyle: {
            "padding-left": "10px",
            "background-size": "120px",
            "background-position": "0px 0px",
            "width": "100%",
            "min-width": "200px"
          },
          style: (_vm.getBackgroundStyle(item.value))
        }, [_vm._v(_vm._s(item.text))])]
      }
    }], null, false, 2106109692),
    model: {
      value: (_vm.step.important),
      callback: function($$v) {
        _vm.$set(_vm.step, "important", $$v)
      },
      expression: "step.important"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23bcda91"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/flow/ui/StepDesigner.vue
// module id = 2484
// module chunks = 1